<template>
  <v-card>
    <v-data-table v-show="false" :items=[]></v-data-table>
    <v-card-title>
      <v-flex text-left sm4 xs12>
        <v-autocomplete outlined dense :no-data-text="$t('message.common.no_records')" v-model="reportFilter.type" :items="listOfReportType" item-text="text" item-value="value" :label="$t('message.report.select_report')"></v-autocomplete>
      </v-flex>
      <v-flex sm5 class="pl-4">
        <template v-if="reportFilter.type === 2 || reportFilter.type === 4 ? filteredData && filteredData.length > 0 : filteredData && filteredData.orderproducts && filteredData.orderproducts.length > 0">
          <v-btn class="mx-1" color="primary" small dark fab @click="generateAsXLSX"><v-icon>mdi-file-excel</v-icon> </v-btn>
          <v-btn class="mx-1" color="red" small dark fab  @click="generatePDF"> <v-icon>mdi-file-powerpoint</v-icon> </v-btn>
          <v-btn class="mx-1" color="blue" small dark fab @click="isValidEmail = false, emailIds = [], filesendtype = 1, emailDialog = true"><v-icon>mdi-send</v-icon> </v-btn>
        </template>
        <template v-if="viewHasData">
          <v-btn fab small dense color="green" dark :loading="excelLoading" @click="generateExcelForInventory">
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </template>
      </v-flex>
    </v-card-title>
    <v-container fluid>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm12 md3 lg3 child-flex>
        <v-card tile>
          <v-card-title class="headline grey lighten-2" primary-title>{{ $t('message.report.filter_action') }}</v-card-title>
          <v-card-text>
            <v-form ref="filterGroup" v-show="reportFilter.type == 2">
                <v-text-field class="pt-4" hide-details outlined dense v-model="reportFilter.number_from" :label="`${$t('message.stocks.productNumber')} ${$t('message.report.from')}`"></v-text-field>
                <v-text-field hide-details class="pt-3" outlined dense v-model="reportFilter.number_till" :label="`${$t('message.stocks.productNumber')} ${$t('message.report.to')}`"></v-text-field>
                <v-autocomplete class="pb-2 pt-3" outlined dense :no-data-text="$t('message.common.no_records')" v-model="reportFilter.groups" :items="listOfProductGroup" :label="$t('message.report.productGroup')" clearable multiple :item-text="val => (val.number ? val.number + ' - ' : '') + val.name || ''" item-value="id">
                  <template slot="selection" slot-scope="data">
                    <span v-if="data.index === 0">{{ (data.item.number ? data.item.number + ' - ' : '') + data.item.name || '-'}}</span>
                    <span
                      v-if="data.index === 1"
                      class="grey--text caption"
                    > (+{{ reportFilter.groups.length - 1 + ' ' + $t('message.common.others')}}) </span>
                  </template>
                </v-autocomplete>
                <v-checkbox color="primary" key="showZeroProduct" class="mt-n6" :label="$t('message.report.showZeroProduct')" v-model="reportFilter.show_zero_product"></v-checkbox>
                <v-menu :close-on-content-click="false" v-model="date_menu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field key="date" class="mt-n2 mb-2" dense outlined clearable :label="$t('message.order.date')" prepend-icon="event" @focusout="datepicker = $formatter.formatDate(reportFilter.date, 'DD.MM.YYYY', 'YYYY-MM-DD')"
                    readonly v-on="on" v-bind="attrs" v-model="reportFilter.date" @focus="datepicker = $formatter.formatDate(reportFilter.date, 'DD.MM.YYYY', 'YYYY-MM-DD')" @click:clear="$nextTick(() => datepicker = null)"
                    :rules="$_requiredValidation"></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="datepicker" @input="date_menu = false; reportFilter.date = $formatter.formatDate(datepicker, 'YYYY-MM-DD', 'DD.MM.YYYY')"
                  first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-form>
              <v-form ref="filterGroup" v-show="reportFilter.type == 3 || reportFilter.type == 4 || reportFilter.type === 5">
                <v-autocomplete v-if="reportFilter.type == 3 || reportFilter.type === 4" outlined dense class="my-2" :no-data-text="$t('message.common.no_records')" v-model="reportFilter.products" multiple :items="listOfProducts"
                  :item-text="val => (val.number ? val.number + ' - ' : '') + val.name || ''" item-value="id" hide-details clearable :label="$t('message.layout.products')">
                  <template slot="selection" slot-scope="data">
                    <span v-if="data.index === 0">{{ (data.item.number ? data.item.number + ' - ' : '') + data.item.name || '-'}}</span>
                    <span
                      v-if="data.index === 1"
                      class="grey--text caption"
                    > (+{{ reportFilter.products.length - 1 + ' ' + $t('message.common.others')}}) </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete v-if="reportFilter.type === 4" outlined dense hide-details :no-data-text="$t('message.common.no_records')" v-model="reportFilter.employees" :items="listOfUsers" :label="$t('message.layout.user')" clearable multiple item-text="name" item-value="id">
                  <template slot="selection" slot-scope="data">
                    <span v-if="data.index === 0">{{ data.item.name }}</span>
                    <span
                      v-if="data.index === 1"
                      class="grey--text caption"
                    > (+{{ reportFilter.groups.length - 1 + ' ' + $t('message.common.others')}}) </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete v-if="reportFilter.type === 5"
                  :class="reportFilter.type === 5 ? 'mt-2' : ''"
                  outlined dense hide-details :no-data-text="$t('message.common.no_records')" v-model="reportFilter.warehouse"
                  :items="listOfWarehouse" :label="$t('message.layout.warehouse')" clearable multiple item-text="name" item-value="id">
                  <template slot="selection" slot-scope="data">
                    <span v-if="data.index === 0">{{ data.item.name }}</span>
                    <span
                      v-if="data.index === 1"
                      class="grey--text caption"
                    > (+{{ reportFilter.groups.length - 1 + ' ' + $t('message.common.others')}}) </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete v-if="reportFilter.type === 3 || reportFilter.type === 5" outlined dense hide-details
                  :class="reportFilter.type === 5 ? 'mt-3 mb-2' : ''"
                  :no-data-text="$t('message.common.no_records')" v-model="reportFilter.productgroups" :items="listOfProductGroup"
                  :label="$t('message.report.productGroup')" clearable multiple :item-text="val => (val.number ? val.number + ' - ' : '') + val.name || ''" item-value="id">
                  <template slot="selection" slot-scope="data">
                    <span v-if="data.index === 0">{{ (data.item.number ? data.item.number + ' - ' : '') + data.item.name || '-'}}</span>
                    <span
                      v-if="data.index === 1"
                      class="grey--text caption"
                    > (+{{ reportFilter.groups.length - 1 + ' ' + $t('message.common.others')}}) </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete v-if="reportFilter.type === 3" outlined dense class="my-2" :no-data-text="$t('message.common.no_records')" v-model="reportFilter.order" :items="listOfOrders"
                  item-text="number" item-value="id" hide-details clearable :label="$t('message.dashboard.orders')">
                </v-autocomplete>
                <v-menu v-if="reportFilter.type == 3 || reportFilter.type === 4" v-model="fromDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined dense class="my-2" clearable v-on="on" readonly hide-details v-model="reportFilter.start" prepend-icon="mdi-calendar" @click:clear="$nextTick(() => reportFilter.fromDatePicker = null)" :label="$t('message.tickets.from')"></v-text-field>
                  </template>
                  <v-date-picker v-model="reportFilter.fromDatePicker" @input="fromDateMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
                </v-menu>
                <v-menu v-if="reportFilter.type == 3 || reportFilter.type === 4" v-model="tillDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined dense class="my-2" clearable v-on="on" readonly hide-details v-model="reportFilter.end" prepend-icon="mdi-calendar" @click:clear="$nextTick(() => reportFilter.tillDatePicker = null)" :label="$t('message.tickets.to')"></v-text-field>
                  </template>
                  <v-date-picker v-model="reportFilter.tillDatePicker" @input="tillDateMenu = false" color="primary" first-day-of-week='1'></v-date-picker>
                </v-menu>
            </v-form>
            <template v-if="reportFilter.type !== 5">
              <v-btn class="mx-1" color="primary" :loading="filterSpin" dark @click="applyFilter()">{{ $t('message.report.filter') }}</v-btn>
              <v-btn color="red" dark class="pull-right mx-1" @click="clearFilter()">{{ $t('message.user.clear') }}</v-btn>
            </template>
            <template v-else>
              <v-btn dense color="green" :loading="loading" dark @click="getInventoryRecords">
                {{ $t('message.report.filter') }}
              </v-btn>
              <v-btn dense color="error" class="ml-2" dark @click="clearFilter">
                {{ $t('message.user.clear') }}
              </v-btn>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 sm12 md9 lg9 ref="filteredResult">
        <v-card width="100%" tile>
          <div class="v-table__overflow" v-if="reportFilter.type === 2 && filteredData && filteredData.length > 0">
            <table style="width: 100%" class="py-3">
              <tr>
                <td width="10%" align="center">RotoStop</td>
                <td width="10%"></td>
                <td width="10%" align="right">{{ $t('message.report.report') }}:</td>
                <td width="20%" align="center">{{ $t('message.report.stockOverview') }}</td>
                <template v-if="reportFilter.type === 3">
                  <td width="10%" align="right">{{ $t('message.datestrings.year') }}:</td>
                  <td width="10%" align="center">{{ materialYear }}</td>
                </template>
                <template v-else>
                  <td width="10%" align="right">{{ $t('message.report.date') }}:</td>
                  <td width="10%" align="center">{{ reportDate }}</td>
                </template>
              </tr>
            </table>
            <br>
            <table class="v-datatable mt-n6 v-table theme--light table table-striped bordered--table table-bordered table-hover padding-remove dense_table custom-table-style" style="width: 95%; border-collapse: collapse; margin: 0 auto" v-if="reportFilter.type === 2">
              <thead>
                <tr>
                  <th v-for="(head, index) in listOfReportHeader" :key="index" class="text-left">
                    {{ head }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template>
                  <tr v-for="(item, index) in filteredData" :key="index">
                    <td width="20%"> {{ item.group }} </td>
                    <td width="10%"> {{ item.number }} </td>
                    <td width="20%"> {{ item.name }} </td>
                    <td width="11%"> {{ item.class }} </td>
                    <td width="13%"> {{ item.qty | replaceDotWithCommaWOFixed }} </td>
                    <td width="13%"> {{ item.weight | replaceDotWithCommaWOFixed }} </td>
                    <td width="13%"> {{ item.std_weight_total | replaceDotWithCommaWOFixed }} </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="v-table__overflow bordered--table v-data-table--dense" v-else-if="reportFilter.type === 3 && filteredData && filteredData.orderproducts && filteredData.orderproducts.length > 0">
            <div class="v-data-table__wrapper bordered--table">
              <table class="v-datatable v-table theme--light table table-striped table-bordered material-report padding-remove dense_table" style="width: 100%">
                <tbody>
                  <tr>
                    <th v-for="(head, hIndex) in productUsageHeaders" :key="hIndex" class="text-left">
                      {{ head }}
                    </th>
                  </tr>
                  <tr v-for="(product, index) in filteredData.orderproducts" :key="index">
                    <td width="9%">
                      <router-link :to="`/production_order/order/actions/${product.orderid}`">{{ product.ordernumber || '' }}</router-link>
                    </td>
                    <td width="30%">{{ product.productnumber ? product.productnumber + ' - ' : '' }} {{ product.productname || '' }}</td>
                    <td width="12%">{{ product.productgroup || '' }}</td>
                    <td width="8%" class="text-right">{{ product.usedqty | replaceDotWithComma }}</td>
                    <td width="17%">{{ product.usedby || '' }}</td>
                    <td width="15%">{{ product.useddate | dateTimeFormat }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="v-table__overflow bordered--table v-data-table--dense" v-else-if="reportFilter.type === 4 && filteredData && filteredData.length > 0">
            <div class="v-data-table__wrapper bordered--table">
              <table class="v-datatable v-table theme--light table table-striped table-bordered material-report padding-remove dense_table" style="width: 100%">
                <thead>
                  <tr>
                    <th class="text-left">{{ $t('message.warehouse.product') }}</th>
                    <th class="text-left">{{ $t('message.customer.name') }}</th>
                    <th class="text-left">{{ $t('message.report.dateTimeStart') }}</th>
                    <th class="text-left">{{ $t('message.report.dateTimeEnd') }}</th>
                    <th class="text-left">{{ $t('message.common.completedBy') }}</th>
                    <th class="text-left">WIN</th>
                    <th class="text-right">{{ $t('message.order.qty') }}</th>
                    <th class="text-right">{{ $t('message.report.bQty') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, index) in filteredData" :key="index">
                    <td>{{ order.product_number }}</td>
                    <td>{{ order.product_name }}</td>
                    <td>{{ order.started_on | dateTimeFormat }}</td>
                    <td>{{ order.completed_on | dateTimeFormat }}</td>
                    <td>{{ order.completed_by }}</td>
                    <td>{{ order.win_number }}</td>
                    <td class="text-right">{{ order.qty | replaceDotWithComma }}</td>
                    <td class="text-right">{{ order.producedqty | replaceDotWithComma }}</td>
                  </tr>
                  <tr>
                    <td colspan="5"></td>
                    <td>{{ $t('message.common.total') }}</td>
                    <td class="text-right">{{ $_getSumBy(filteredData, x => x.qty) | replaceDotWithComma }}</td>
                    <td class="text-right">{{ $_getSumBy(filteredData, x => x.producedqty) | replaceDotWithComma }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <template v-else-if="reportFilter.type === 5 && viewHasData">
            <inventory class="pl-1" :inventoryObj="inventoryData"></inventory>
          </template>
          <div class="v-table__overflow" v-else>
            <div class="text-center mt-15">
              <h3>{{ $t('message.report.empty_filter') }}</h3>
            </div>
          </div>
        </v-card>
      </v-flex>
      <v-dialog v-model="emailDialog" width="400" persistent>
        <v-card >
          <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.report.send_report') }} </v-card-title>
          <v-card-text>
            <v-form ref="sendEmailForm">
              <v-text-field  v-model="sendEmailData.emailIds" :label="$t('message.customer.email')" type="text" :rules="required_validation"></v-text-field>
              {{ $t('message.report.add_extra_mails') }}
              <v-autocomplete v-model="filesendtype" :items="listSentEmailOptions" :no-data-text="$t('message.common.no_records')" :label="$t('message.report.file_type')" item-text="title" item-value="value"></v-autocomplete>
            </v-form>
          </v-card-text>
          <v-card-actions class="text-lg-right">
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="sendReport()" :loading="loading"> {{ $t('message.common.ok') }} </v-btn>
            <v-btn color="error" dark @click="emailDialog = false, sendEmailData.emailIds = null">{{ $t('message.common.cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      reportFilter: {
        type: 2,
        product_group: 0,
        number_from: '',
        number_till: '',
        groups: [],
        show_zero_product: false,
        date: moment().format('DD.MM.YYYY')
      },
      filterSpin: false,
      fromdate_menu: false,
      tilldate_menu: false,
      date_menu: false,
      datepicker: '',
      setMin: '',
      emailDialog: false,
      sendEmailData: {},
      filesendtype: 1,
      isValidEmail: false,
      loading: false,
      listOfProductGroup: [],
      listOfWarehouse: [],
      viewHasData: false,
      excelLoading: false,
      listOfProducts: [],
      listOfOrders: [],
      filteredData: [],
      reportDate: '',
      materialYear: '',
      currentDate: moment().format('DD.MM.YYYY'),
      required_validation: [val => !!val || this.$t('message.common.validationIssue')],
      listOfYears: [],
      listOfMonths: Array.from({ length: 12 }, (v, k) => k + 1),
      selectedMonthsList: [],
      materialReportData: [],
      fromDateMenu: false,
      tillDateMenu: false,
      inventoryData: {}
    }
  },
  components: {
    inventory: () => import('@/components/Reports/Inventory.vue')
  },
  mounted () {
    this.$store.dispatch('getUsers')
    this.getProductGroup()
    this.getProducts()
    this.getOrders()
    this.getWarehouse()
    const year = moment().year()
    for (let i = 0; i < 4; i++) {
      if (i <= 2) this.listOfYears.unshift(year - i)
      else this.listOfYears.push(year + 1)
    }
  },
  watch: {
    'reportFilter.type' () {
      this.getProducts()
      this.clearFilter()
    },
    datepicker (val) {
      this.reportFilter.date = val ? moment(this.datepicker).format('DD.MM.YYYY') : null
    },
    'reportFilter.fromDatePicker' (val) {
      if (val) {
        this.reportFilter.start = val ? moment(val).format('DD.MM.YYYY') : null
      }
    },
    'reportFilter.tillDatePicker' (val) {
      if (val) {
        this.reportFilter.end = val ? moment(val).format('DD.MM.YYYY') : null
      }
    },
    '$i18n.locale' (val) {
      this.prepareReportContent()
    }
  },
  computed: {
    ...mapState(['listOfUsers']),
    listOfReportType () {
      return [
        // { text: this.$t('message.report.producedProductWeight'), value: 1 },
        { text: this.$t('message.report.stockOverview'), value: 2 },
        { text: this.$t('message.report.productUsage'), value: 3 },
        { text: this.$t('message.report.productionReport'), value: 4 },
        { text: this.$t('message.report.inventoryReport'), value: 5 }
      ]
    },
    stockOverview () {
      return [this.$t('message.report.productGroup'), this.$t('message.report.productNumber'), this.$t('message.report.productName'),
        this.$t('message.report.productClass'), this.$t('message.report.onStock'), this.$t('message.report.standardWeight'),
        this.$t('message.report.stdWeightTotal')]
    },
    productUsageHeaders () {
      return [this.$t('message.warehouse.order'), this.$t('message.warehouse.product'), this.$t('message.report.productGroup'), this.$t('message.report.usedQty'),
        this.$t('message.report.usedBy'), this.$t('message.report.usedDate')]
    },
    listOfReportHeader () {
      return this.stockOverview
    },
    listSentEmailOptions () {
      return [{
        value: 1,
        title: this.$t('message.report.only_pdf')
      },
      {
        value: 2,
        title: this.$t('message.report.only_xlsx')
      },
      {
        value: 3,
        title: this.$t('message.report.both')
      }
      ]
    }
  },
  methods: {
    getProductGroup () {
      this.$_getSingleRecordHandler('productgroups')
        .then((response) => {
          this.listOfProductGroup = response.data
        })
    },
    getWarehouse () {
      this.$_getSingleRecordHandler('warehouses')
        .then((response) => {
          this.listOfWarehouse = response.data
        })
    },
    getProducts () {
      this.$_getSingleRecordHandler('products')
        .then((response) => {
          const condition = this.reportFilter.type === 4 ? x => x.isactive && x.workflow_id : x => x.isactive
          this.listOfProducts = response.data.filter(condition)
        })
    },
    getInventoryRecords () {
      const model = { warehouseids: this.reportFilter.warehouse || [], productgroupids: this.reportFilter.productgroups || [] }
      this.$_executeApi('post', '/stocks/get_inventory_report', model)
        .then((response) => {
          this.inventoryData = response.data
          if (this.inventoryData.inventoryrecords && this.inventoryData.inventoryrecords.length > 0) this.viewHasData = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    generateExcelForInventory () {
      this.excelLoading = true
      const model = { warehouseids: this.reportFilter.warehouse || [], productgroupids: this.reportFilter.productgroups || [] }
      this.$_executeApi('post', '/stocks/generate_excel_inventory', model)
        .then((response) => {
          var fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.excelLoading = false
        })
    },
    getOrders () {
      this.$_getSingleRecordHandler('productionorders')
        .then((response) => {
          this.listOfOrders = response.data
        })
    },
    sendReport () {
      if (this.$refs.sendEmailForm.validate()) {
        if (!this.sendEmailData.emailIds.length > 0) this.isValidEmail = true
        const getMailIDsString = this.sendEmailData.emailIds
        const listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              if (this.validEmail(listOfMailIds[i])) this.isValidEmail = false
              else this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          this.loading = true
          let model = {}
          const date = moment(this.reportDate, 'DD.MM.YYYY').format('DDMMYY')
          let filename = ''
          switch (this.reportFilter.type) {
            case 1:
              filename = `weightreport_${moment().format('DDMMYY')}.pdf`
              break
            case 2:
              filename = `stock_${date}.pdf`
              break
            case 3:
              filename = `product_usage_${date}.pdf`
              break
            default:
              break
          }
          model = JSON.parse(JSON.stringify(this.reportFilter))
          if (this.filesendtype === 1) {
            model = { to: listOfMailIds, filesendtype: this.filesendtype }
            model.content = this.getPDFContent()
          } else if (this.filesendtype === 2) {
            model.to = listOfMailIds
            model.filesendtype = this.filesendtype
          } else {
            model.to = listOfMailIds
            model.filesendtype = this.filesendtype
            model.content = this.getPDFContent()
          }
          model.filename = filename
          model.start = moment(model.start, 'DD.MM.YYYY').isValid() ? moment(model.start, 'DD.MM.YYYY').format('MM.DD.YYYY HH:mm:ss') : null
          model.end = moment(model.end, 'DD.MM.YYYY').isValid() ? moment(model.end, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59') : null
          model.date = moment(model.date, 'DD.MM.YYYY').isValid() ? moment(model.date, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59') : null
          this.$_executeApi('post', 'productreports/share', model)
            .then((response) => {
              this.loading = false
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.report.sent_success') })
              this.sendEmailData.emailIds = ''
              this.emailDialog = false
            }).finally(() => {
              this.loading = false
            })
        }
      }
    },
    /* Validation for Email */
    validEmail: function (email) {
      /* eslint-disable */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    getPDFContent () {
      let styleLink = `<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
        <style>
        .report_header{background: #354759 !important;color: white;}
        .table {font-family: initial;}
        .padding-remove { padding: 0 }
        .material-report>tbody>tr>td, .material-report>tbody>tr>th {
          padding: 1px;
        }
        tbody tr    { page-break-inside:avoid;}
        tbody tr td { word-break: break-word;}
        </style>`
      let getHTMLContent = `<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" />
        <meta charset="utf-8"/>${styleLink}</head><body><div class="container">${this.$refs.filteredResult.innerHTML}</div></body></html>`
      return btoa(unescape(encodeURIComponent(getHTMLContent)))
    },
    // Generate as XLSX file
    generateAsXLSX () {
      this.$store.commit('showFullLoader')
      let reportFilter = JSON.parse(JSON.stringify(this.reportFilter))
      reportFilter.start = moment(reportFilter.start, 'DD.MM.YYYY').isValid() ? moment(reportFilter.start, 'DD.MM.YYYY').format('MM.DD.YYYY HH:mm:ss') : null
      reportFilter.end = moment(reportFilter.end, 'DD.MM.YYYY').isValid() ? moment(reportFilter.end, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59') : null
      reportFilter.date = moment(reportFilter.date, 'DD.MM.YYYY').isValid() ? moment(reportFilter.date, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59') : null
      if (!reportFilter.order) reportFilter.order = 0
      let url = ''
      if (reportFilter.type === 2) url = 'productreports/generate_xlsx'
        else if (reportFilter.type === 3) url = 'productionorders/generate_xlsx_for_products'
        else if (reportFilter.type === 4) url = 'productionorders/generate_xlsx'
      this.$_executeApi('post', url, reportFilter)
        .then((response) => {
          let fileName = response.data
          this.$store.commit('hideFullLoader')
          window.open(`${process.env.VUE_APP_URL}file/download/?fileName=` + fileName, '_blank')
        })
        .catch((error) => {
          this.$store.commit('hideFullLoader')
        })
    },
    // Generate as PDF file
    generatePDF () {
      this.$store.commit('showFullLoader')
      let date = moment(this.reportDate, 'DD.MM.YYYY').format('DDMMYY')
      let filename = ''
      switch (this.reportFilter.type) {
        case 1:
          filename = `weightreport_${moment().format('DDMMYY')}.pdf`
          break
        case 2:
          filename = `stock_${date}.pdf`
          break
        case 3:
          filename = `product_usage_${date}.pdf`
          break
        case 4:
          filename = `daily_production_${date}.pdf`
          break
        default:
          break
      }
      var getBase64Content = { content: this.getPDFContent(), filename }
      this.$_executeApi('post', 'productreports/generate_pdf', getBase64Content)
        .then((response) => {
          let fileName = response.data
          this.$store.commit('hideFullLoader')
          window.open(`${process.env.VUE_APP_URL}/file/download?fileName=` + fileName, '_blank')
        })
    },
    // apply filter per project
    applyFilter () {
      if (this.$refs.filterGroup.validate()) {
        this.filterSpin = true
        this.filteredData = []
        let url = ''
        let reportFilter = JSON.parse(JSON.stringify(this.reportFilter))
        if (reportFilter.type === 2) url = 'productreports/preview_stock_overview_report'
        else if (reportFilter.type === 3) url = 'productionorders/generate_report'
        else if (reportFilter.type === 4) url = 'productionorders/get_daily_production_report'
        reportFilter.start = moment(reportFilter.start, 'DD.MM.YYYY').isValid() ? moment(reportFilter.start, 'DD.MM.YYYY').format('MM.DD.YYYY HH:mm:ss') : null
        reportFilter.end = moment(reportFilter.end, 'DD.MM.YYYY').isValid() ? moment(reportFilter.end, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59') : null
        reportFilter.date = moment(reportFilter.date, 'DD.MM.YYYY').isValid() ? moment(reportFilter.date, 'DD.MM.YYYY').format('MM.DD.YYYY 23:59:59') : null
        this.reportDate = moment(reportFilter.date).format('DD.MM.YYYY')
        this.materialYear = reportFilter.year
        if (!reportFilter.order) reportFilter.order = 0
        this.$_executeApi('post', `${url}`, reportFilter)
          .then((response) => {
            this.filteredData = response.data
            this.filterSpin = false
            if (this.reportFilter.type === 3) {
              this.prepareReportContent()
            }
          }).finally(() => {
            this.filterSpin = false
          })
      }
    },
    prepareReportContent () {
      this.selectedMonthsList = []
      this.materialReportData = []
      let result = this.$formatter.cloneVariable(this.filteredData)
      let lang = this.$i18n.locale === 'no' ? 'nb' : 'en'
      if (result && result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.selectedMonthsList = result[i].reportresultpermonths.map(function (x) {
            return { id: x.month, text: moment().locale(lang).month(x.month - 1).format('MMM'), amount: x.amount }
          })
        }
        this.materialReportData = result
      }
    },
    clearFilter () {
      this.filteredData = []
      this.inventoryData = {}
      this.viewHasData = false
      this.$refs.filterGroup.reset()
      this.datepicker = ''
      this.reportFilter.date = moment().format('DD.MM.YYYY')
      this.reportFilter.year = moment().year()
    }
  }
}
</script>
<style>
.material-report.v-table tbody td:not(:nth-child(1)), .material-report.v-table tbody th:not(:nth-child(1)) {
  padding: 1px;
}
.custom-table-style th, .custom-table-style td {
  border: 1px solid rgba(0,0,0,0.12) !important;
}
</style>
